// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/register/partner_registrations/firstparty/v1/partner_registration.proto

/* eslint-disable */

/** Status of a partner registration */
export const ApiStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * Registration is pending
   */
  pending: "pending",
  /**
   * Contract signing is pending
   */
  contract_sign_pending: "contract_sign_pending",
  /**
   * Contract signing had a validation error
   */
  contract_sign_validation_error: "contract_sign_validation_error",
  /**
   * Contract has been signed
   */
  contract_signed: "contract_signed",
  /**
   * Registration is completed
   */
  completed: "completed",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type STATUS_UNSPECIFIED = typeof ApiStatus.STATUS_UNSPECIFIED;
  export type pending = typeof ApiStatus.pending;
  export type contract_sign_pending = typeof ApiStatus.contract_sign_pending;
  export type contract_sign_validation_error = typeof ApiStatus.contract_sign_validation_error;
  export type contract_signed = typeof ApiStatus.contract_signed;
  export type completed = typeof ApiStatus.completed;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiStatus.STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiStatus.pending;
    case 2:
    case "contract_sign_pending":
      return ApiStatus.contract_sign_pending;
    case 3:
    case "contract_sign_validation_error":
      return ApiStatus.contract_sign_validation_error;
    case 4:
    case "contract_signed":
      return ApiStatus.contract_signed;
    case 5:
    case "completed":
      return ApiStatus.completed;
    default:
      return ApiStatus.STATUS_UNSPECIFIED;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiStatus.pending:
      return "pending";
    case ApiStatus.contract_sign_pending:
      return "contract_sign_pending";
    case ApiStatus.contract_sign_validation_error:
      return "contract_sign_validation_error";
    case ApiStatus.contract_signed:
      return "contract_signed";
    case ApiStatus.completed:
      return "completed";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

/** Flow type for registration eligibility */
export const ApiFlowType = {
  /** FLOW_TYPE_UNSPECIFIED - Unspecified flow type */
  FLOW_TYPE_UNSPECIFIED: "FLOW_TYPE_UNSPECIFIED",
  /**
   * User signs up through qonto.com
   */
  manual: "manual",
  /**
   * User signs up through partner-register.qonto.com
   */
  seamless: "seamless",
} as const;

export type ApiFlowType = typeof ApiFlowType[keyof typeof ApiFlowType];

export namespace ApiFlowType {
  export type FLOW_TYPE_UNSPECIFIED = typeof ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  export type manual = typeof ApiFlowType.manual;
  export type seamless = typeof ApiFlowType.seamless;
}

export function apiFlowTypeFromJSON(object: any): ApiFlowType {
  switch (object) {
    case 0:
    case "FLOW_TYPE_UNSPECIFIED":
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
    case 1:
    case "manual":
      return ApiFlowType.manual;
    case 2:
    case "seamless":
      return ApiFlowType.seamless;
    default:
      return ApiFlowType.FLOW_TYPE_UNSPECIFIED;
  }
}

export function apiFlowTypeToJSON(object: ApiFlowType): string {
  switch (object) {
    case ApiFlowType.FLOW_TYPE_UNSPECIFIED:
      return "FLOW_TYPE_UNSPECIFIED";
    case ApiFlowType.manual:
      return "manual";
    case ApiFlowType.seamless:
      return "seamless";
    default:
      return "FLOW_TYPE_UNSPECIFIED";
  }
}

/** PartnerRegistration represents a partner registration resource */
export interface ApiPartnerRegistration {
  /** Unique identifier of the partner registration */
  readonly id: string;
  /** Name of the partner */
  readonly partnerName: string;
  /** Type of partner (e.g. "legal_tech") */
  readonly partnerType: string;
  /** Flow this registration is eligible for */
  readonly flowType: ApiFlowType;
  /** URL where the user will be redirected after registration completion (embed apps only) */
  readonly partnerRedirectUrl?:
    | string
    | null
    | undefined;
  /** ID of the organization linked to this partner registration */
  readonly organizationId: string;
  /** Current status of the partner registration */
  readonly status: ApiStatus;
  /** OAuth parameters for partner authentication (only present when configured) */
  readonly partnerOauthParams?: ApiPartnerOauthParams | null | undefined;
}

/** OAuth parameters for partner authentication */
export interface ApiPartnerOauthParams {
  /** OAuth client identifier */
  readonly clientId: string;
  /** OAuth state parameter */
  readonly state: string;
  /** OAuth redirect URI */
  readonly redirectUri: string;
  /** OAuth scopes requested */
  readonly scopes: readonly string[];
}

export const ApiPartnerRegistration: MessageFns<ApiPartnerRegistration> = {
  fromJSON(object: any): ApiPartnerRegistration {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      partnerName: isSet(object.partnerName) ? globalThis.String(object.partnerName) : "",
      partnerType: isSet(object.partnerType) ? globalThis.String(object.partnerType) : "",
      flowType: isSet(object.flowType) ? apiFlowTypeFromJSON(object.flowType) : ApiFlowType.FLOW_TYPE_UNSPECIFIED,
      partnerRedirectUrl: isSet(object.partnerRedirectUrl) ? globalThis.String(object.partnerRedirectUrl) : null,
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      partnerOauthParams: isSet(object.partnerOauthParams)
        ? ApiPartnerOauthParams.fromJSON(object.partnerOauthParams)
        : null,
    };
  },

  toJSON(message: ApiPartnerRegistration): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.partnerName !== undefined && message.partnerName !== null) {
      obj.partnerName = message.partnerName;
    }
    if (message.partnerType !== undefined && message.partnerType !== null) {
      obj.partnerType = message.partnerType;
    }
    if (message.flowType !== undefined && message.flowType !== null) {
      obj.flowType = apiFlowTypeToJSON(message.flowType);
    }
    if (message.partnerRedirectUrl !== undefined && message.partnerRedirectUrl !== null) {
      obj.partnerRedirectUrl = message.partnerRedirectUrl;
    }
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organizationId = message.organizationId;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.partnerOauthParams !== undefined && message.partnerOauthParams !== null) {
      obj.partnerOauthParams = ApiPartnerOauthParams.toJSON(message.partnerOauthParams);
    }
    return obj;
  },
};

export const ApiPartnerOauthParams: MessageFns<ApiPartnerOauthParams> = {
  fromJSON(object: any): ApiPartnerOauthParams {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : "",
      state: isSet(object.state) ? globalThis.String(object.state) : "",
      redirectUri: isSet(object.redirectUri) ? globalThis.String(object.redirectUri) : "",
      scopes: globalThis.Array.isArray(object?.scopes) ? object.scopes.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ApiPartnerOauthParams): unknown {
    const obj: any = {};
    if (message.clientId !== undefined && message.clientId !== null) {
      obj.clientId = message.clientId;
    }
    if (message.state !== undefined && message.state !== null) {
      obj.state = message.state;
    }
    if (message.redirectUri !== undefined && message.redirectUri !== null) {
      obj.redirectUri = message.redirectUri;
    }
    if (message.scopes?.length) {
      obj.scopes = message.scopes;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
